import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { find, filter, get } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { IconButton, Menu, MenuItem, Paper, Grid } from '@material-ui/core';
import { MoreHoriz } from '@material-ui/icons';
import { HeaderTable, PaperHeader } from '../../../../app/components';
import AddCourse from '../../../courses/components/AddCourse';
import CustomSelect from '../../../../app/components/Select';

import styles from './styles';

import {
  fetchCourseRequests,
  resolveCourseRequest,
  approveInHomeTutoringRequest,
  declineInHomeTutoringRequest
 } from '../../actions';
import { fetchTutors } from '../../../tutors/actions';
import {
  getTutors,
} from '../../selectors';
import { loadTexts } from '../../../../config/texts';

import {
  courseTitleChanged,
  courseSubjectChanged,
  courseNumberChanged,
  courseUniversityChanged,
  clearCourseFields,
} from '../../../courses/components/AddCourse/actions';
import { getCourseRequests } from '../../selectors';
const TEXT_KEY = "requests";

class CourseRequestsCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      request: '',
      anchorEl: null,
      texts: loadTexts(TEXT_KEY, props.locale),
      requestTitle: 'Course Requests'
    };
    this._onRowClick = this._onRowClick.bind(this);
    this._onClose = this._onClose.bind(this);
    this._onSubmit = this._onSubmit.bind(this);
    this._onMoreACtions = this._onMoreActions.bind(this);
    this._onCloseMenu = this._onCloseMenu.bind(this);
    this._onResolveCourseRequest = this._onResolveCourseRequest.bind(this);
    this._changeRequest = this._changeRequest.bind(this);
    this._onFetchTutors = this._onFetchTutors.bind(this);
  }

  componentDidMount() {
    // fetch course requests here
    this.props.fetchCourseRequests();
    this._onFetchTutors();
  }

  _onFetchTutors() {
    const { selectedUniversity, selectedOrganization } = this.props;
    this.props.fetchTutors({ tutorSearchInput: {
      _universities: [selectedUniversity],
      _organizations: [selectedOrganization],
      approved: true,
    } });
  }

  _onRowClick() {
    const { requestObj: { _id, code, title, university } } = this.state;
    const { universities } = this.props;
    const split = code.split(' ');
    const subject = split[0] || '';
    let number = split[1] || '';
    split.forEach((s, i) => {
      if (i > 1) number = `${number} ${s}`;
    });

    const uni = find(universities, u => u.name === university);

    // this.props.courseUniversityChanged();
    this.setState({ open: true, request: _id }, () => {
      this.props.courseTitleChanged(title || '');
      this.props.courseSubjectChanged(subject);
      this.props.courseNumberChanged(number);
      this.props.courseUniversityChanged(uni._id);
    });
  }

  _onClose() {
    this.setState({ open: false });
  }

  async _onSubmit() {
    // add course to tutor and resolve request;
    const { subject, number, title, university } = this.props;
    await this.props.resolveCourseRequest({
      request: this.state.request,
      courseInput: { subject, number, title },
      university,
    });
    await this.props.fetchCourseRequests();
    this.setState({ open: false, anchorEl: null });
    this.props.clearCourseFields();
  }

  _onMoreActions(request) {
    return event => {
      this.setState({
        anchorEl: event.currentTarget,
        request: request._id,
        requestObj: request,
      });
    };
  }

  _onCloseMenu() {
    this.setState({ anchorEl: null });
  }

  _changeRequest(requestTitle) {
    this.setState({ requestTitle });
  }

  async _onResolveCourseRequest() {
    await this.props.resolveCourseRequest({
      request: this.state.request,
    });
    this.props.fetchCourseRequests();
    this.setState({ anchorEl: null });
  }

  render() {
    const { requests, tutors } = this.props;
    const { open, anchorEl, requestTitle, request, texts } = this.state;
    const pendingTutors = filter(tutors, t => t.privateLocationsStatus === 'REQUESTED');
    const isCourse = requestTitle === 'Course Requests';
    return (
      <Paper>
        <Grid container justify="flex-start" alignItems="flex-end" className={styles.gridContainer}>
          <PaperHeader text={requestTitle} />
          <CustomSelect
            dataArray={['Course Requests', 'In Home Tutoring Requests']}
            onValueChange={this._changeRequest}
            withDefault
            title={texts.title.requests}
          />
        </Grid>
        <HeaderTable
          label="course_requests"
          data={isCourse ? requests : pendingTutors}
          Action={datum => (
            <IconButton onClick={this._onMoreActions(datum)}>
              <MoreHoriz />
            </IconButton>
          )}
        />
        <AddCourse
          open={open}
          mode="add"
          onClose={this._onClose}
          onSubmit={this._onSubmit}
          add={false}
          message="If there's another course with the same course code in the database, the course will not be added and the requester will still be notified"
        />
        <Menu
          id="location-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this._onCloseMenu}
        >
          <MenuItem
            onClick={
              isCourse
              ? this._onRowClick
              : async () => {
                await this.props.approveInHomeTutoringRequest({ tutor: request });
                this._onFetchTutors();
                this.setState({ anchorEl: null });
              }
            }
          >
            {isCourse ? 'Resolve' : 'Approve'}
          </MenuItem>
          {!isCourse && (
            <MenuItem
              onClick={async () => {
                await this.props.declineInHomeTutoringRequest({ tutor: request });
                this._onFetchTutors();
                this.setState({ anchorEl: null });
              }}
            >
              {'Decline'}
            </MenuItem>
          )}
        </Menu>
      </Paper>
    );
  }
}

CourseRequestsCard.propTypes = {
  fetchCourseRequests: PropTypes.func.isRequired,
  resolveCourseRequest: PropTypes.func.isRequired,
  courseTitleChanged: PropTypes.func.isRequired,
  courseSubjectChanged: PropTypes.func.isRequired,
  courseNumberChanged: PropTypes.func.isRequired,
  courseUniversityChanged: PropTypes.func.isRequired,
  clearCourseFields: PropTypes.func.isRequired,
  requests: PropTypes.array,
  universities: PropTypes.array,
};

CourseRequestsCard.defaultProps = {
  requests: [],
  universities: [],
};

const mapStateToProps = state => ({
  requests: getCourseRequests(state),
  universities: state.auth.data.user.universities,
  selectedUniversity: state.auth.selectedUniversity,
  selectedOrganization: state.auth.selectedOrganization,
  tutors: getTutors(state),
  subject: get(state, 'courses.input.subject'),
  number: get(state, 'courses.input.number'),
  title: get(state, 'courses.input.title'),
  university: get(state, 'courses.input.university'),
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  fetchCourseRequests: () => dispatch(fetchCourseRequests()()),
  resolveCourseRequest: params => dispatch(resolveCourseRequest(params)()),
  courseTitleChanged: params => dispatch(courseTitleChanged(params)),
  courseSubjectChanged: params => dispatch(courseSubjectChanged(params)),
  courseNumberChanged: params => dispatch(courseNumberChanged(params)),
  courseUniversityChanged: params => dispatch(courseUniversityChanged(params)),
  clearCourseFields: () => dispatch(clearCourseFields()),
  fetchTutors: params => dispatch(fetchTutors(params)()),
  approveInHomeTutoringRequest: params => dispatch(approveInHomeTutoringRequest(params)()),
  declineInHomeTutoringRequest: params => dispatch(declineInHomeTutoringRequest(params)()),
});

export default compose(
  withStyles(styles, { name: 'CourseRequestsCard' }),
  connect(mapStateToProps, mapDispatchToProps)
)(CourseRequestsCard);



// WEBPACK FOOTER //
// ./src/modules/requests/cards/CourseRequestsCard/index.js